/**
 * @generated SignedSource<<de017226c2394945d8d75ee2f8a2ace8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RuleSubruleDeleteInputObject = {
  perspectiveId?: string | null | undefined;
  subruleId: string;
};
export type ruleDetailPage_SubruleDeleteMutation$variables = {
  input: RuleSubruleDeleteInputObject;
};
export type ruleDetailPage_SubruleDeleteMutation$data = {
  readonly ruleSubruleDelete: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ruleDetailPage_SubruleDeleteMutation = {
  response: ruleDetailPage_SubruleDeleteMutation$data;
  variables: ruleDetailPage_SubruleDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleDetailPage_SubruleDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleSubruleDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "ruleSubruleDelete",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleDetailPage_SubruleDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleSubruleDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "ruleSubruleDelete",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c1671520f0f7a08adbdc5f334532da6",
    "id": null,
    "metadata": {},
    "name": "ruleDetailPage_SubruleDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ruleDetailPage_SubruleDeleteMutation(\n  $input: RuleSubruleDeleteInputObject!\n) {\n  ruleSubruleDelete(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a0cd3c82d9402026168ac12df7ea6c0";

export default node;
